var BaseClass = require('./BaseClass'),
    Channel = require('jschannel'),
    utils = require('@axd/widgets-utils'),
    url_tools = require('./url_tools');


var settings = {
    coursetalkUrl: CT_ENV_HOST
};


var FrameContainer = BaseClass.create({
    init: function (containerId, default_theme, default_provider) {
        this.default_theme = default_theme || 'default';
        this.default_provider = default_provider || '';
        var elements = document.getElementsByClassName('ct-link-logo');
        if (elements && elements[0]) {
            elements[0].style.display = "none";

            elements[0].getElementsByTagName('a')[0]
            .addEventListener('click', this._handleCTLogoClick.bind(this));
        }
        this.widgetContainer = window.document.getElementById(containerId);
        this._getWidgetData();
    },

    getBasePath: function () {
        return '/widgets/iframe-review-widget/';
    },

    _getWidgetData: function () {
        this.courseKey = this._getCourseKey();
        this.widgetTheme = utils.trim(this.widgetContainer.getAttribute('data-theme')) || this.default_theme;
        this.providerKey = utils.trim(this.widgetContainer.getAttribute('data-provider')) || this.default_provider;
    },

    _getCourseKey: function () {
        var course_id = utils.trim(this.widgetContainer.getAttribute('data-course'));
        if (!course_id){
            course_id = this._getCurrentPageUrl();
        }
        return course_id;
    },

    _getCurrentPageUrl: function () {
        return window.location.href;
    },

    _buildQuery: function (url, data) {
        var basePath = utils.join(url, data.widgetTheme);
        if (data.providerKey) {
            basePath = utils.join(basePath, data.providerKey);
        }
        basePath = utils.join(basePath, data.courseKey);
        return basePath;
    },

    _getFrameURL: function () {
        var basePath = this._buildQuery(this.getBasePath(), {
            widgetTheme: this.widgetTheme,
            providerKey: this.providerKey,
            courseKey: this.courseKey
        });
        var current_url = this._getCurrentPageUrl();
        return url_tools.cloneUrlParams(current_url, basePath, ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']);
    },

    _template: function () {
        return '<iframe src="' + utils.join(settings.coursetalkUrl, this._getFrameURL()) + '" id="ct_widget_iframe" ' +
            'class="ct-iframe" style="display: none" scrolling="no"></iframe>'
    },

    showWidget: function () {
        this.widgetContainer.innerHTML = this._template();
        this.iframeElement = window.document.getElementById('ct_widget_iframe');
        this.iframeElement.addEventListener('load', this._handleIFrameLoad.bind(this), false);
    },

    _handleIFrameLoad: function () {
        this.chan = Channel.build({
            window: this.iframeElement.contentWindow,
            origin: "*",
            scope: "courseTalkWidgetScope",
            onReady: function() {}
        });
        this.chan.bind("resize", this._chanMessageResize.bind(this));
        this.chan.bind("isMultipleColumns", this.isMultipleColumns.bind(this));
        this.chan.bind("addJSON_LD", this.addJSON_LD.bind(this));
        this.chan.bind("getCurrentPageUrl", this._getCurrentPageUrl.bind(this));
        window.addEventListener('resize', this._handleWindowResize.bind(this), false);
    },

    _chanMessageResize: function (trans, s) {
        this.iframeElement.style.height= s + "px";
        if (this.iframeElement.style.display == 'none') {
            this.iframeElement.style.display = "block";
            var elements = document.getElementsByClassName('ct-link-logo');
            if (elements && elements[0]) {
                elements[0].style.display = "block";
            }
            this._handleWindowResize();
        }
    },

    _handleWindowResize: function () {
        this.chan.call({method: 'getHeight',
           success: function (s) {
               this.iframeElement.style.height= s + "px";
           }.bind(this)})
    },

    _handleCTLogoClick: function (event) {
        this.chan.notify({ method:"trackCTLogoClick" });
    },

    isMultipleColumns: function () {
        var classes = this.widgetContainer.className;
        return classes.indexOf("ct--multiple-columns") > -1;

    },

    addJSON_LD: function (trans, jsonSting) {
        var script = document.createElement('script');
        script.setAttribute('type', 'application/ld+json');
        script.innerText = jsonSting;
        document.body.appendChild(script);
    }
});

module.exports = FrameContainer;



/*****************
 ** WEBPACK FOOTER
 ** ./client/helpers/FrameContainer.js
 ** module id = 7
 ** module chunks = 0
 **/